function BackArrow({width=15,height=15}) {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 7.0007H3.83001L8.71001 2.1207C9.10001 1.7307 9.10001 1.0907 8.71001 0.700703C8.32001 0.310703 7.69001 0.310703 7.30001 0.700703L0.710011 7.2907C0.320011 7.6807 0.320011 8.3107 0.710011 8.7007L7.30001 15.2907C7.69001 15.6807 8.32001 15.6807 8.71001 15.2907C9.10001 14.9007 9.10001 14.2707 8.71001 13.8807L3.83001 9.0007H15C15.55 9.0007 16 8.5507 16 8.0007C16 7.4507 15.55 7.0007 15 7.0007Z" fill="#553D81" />
        </svg>
    )
}

export default BackArrow;